export default "__VITE_ASSET__CKNEQlFA__"